// @ts-nocheck
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { getText } from "../../../../utils/util";
import "./index.css";
import { PledgeListStatus,getLabel } from "../../../../utils/dict";

export default function CenterPage({ list }) {
  const navigate = useNavigate();
  const { t: translate } = useTranslation();
  const statusStr = [
    translate(getText("未申请")),
    translate(getText("申请中")),
    translate(getText("质押成功")),
    translate(getText("质押失败")),
  ];

  const getArray = () => {
    const nodes = [];
    for (const item of list) {
      nodes.push(
        <div
          className="c2ccell-2"
          onClick={() => {
            navigate(`/repaymentInfo/${item?.orderNo}`);
          }}
        >
          <div className="c2ccell-3">
            <span className="c2ccell-4">{item.status == 5 && '-'}{item?.num||<span>&nbsp;</span>}</span>
            <div className="c2ccell-5">
              <span className="c2ccell-6">{item?.createTime}</span>
            </div>
          </div>
          <div className="c2ccell-7">
            <div className="c2ccell-8">{translate(getText(getLabel(PledgeListStatus,item.status)))}</div>
            <div className="c2ccell-9">{item?.orderNo}</div>
          </div>
        </div>
      );
    }
    return nodes;
  };
  return (
    <div role="feed" aria-busy="false" className="c2ccell-1">
      {getArray()}
      <div className="c2ccell-18">{translate(getText("没有更多数据了"))}</div>
      <div className="c2ccell-19"></div>
    </div>
  );
}
